import { Injectable } from '@angular/core';
import { NgxsFirestore } from '@ngxs-labs/firestore-plugin';
import { studentRoot } from '../../models/student_root';

@Injectable({
  providedIn: 'root',
})
export class StudentFireStore extends NgxsFirestore<studentRoot> {
  protected path = 'school_student';
}
